import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {StageGoalIcon} from '../icon/svg/stage-goal-icon';
import {Stack} from '../layout/stack/stack';
import {Link} from '../link/link';
import {Body} from '../typography/body';

import styles from './stage-status-hoverview.module.css';

type Props = {
    name: string;
    goals: string[] | null | undefined;
    guidance: string | null | undefined;
    timeInStage: string | null | undefined;
    isActive: boolean;
    pipelineId: string;
    canAccessSetup: boolean;
};

export function StageStatusHoverview(props: Props) {
    const renderGuidanceContent = () => {
        if (props.guidance) {
            return props.guidance;
        }

        if (props.canAccessSetup) {
            return (
                <Link
                    // @ts-expect-error
                    as={RoutedLink}
                    variant='primary'
                    to={`/setup/sales-automation/${props.pipelineId}`}
                >
                    Add guidance for your {props.name} stage
                </Link>
            );
        }

        return `Guidance has not been set for ${props.name}`;
    };

    return (
        <div className={styles['stage-status-hoverview']}>
            <Body
                size='large'
                isBold={true}
                as='div'
                truncate={{type: 'inline'}}
                title={props.name}
            >
                {props.name}
            </Body>
            {props.isActive && (
                <Stack spacing={4}>
                    <Body size='small' color='dark' isBold={true} as='div'>
                        Time in stage
                    </Body>
                    <Stack isHorizontal={true} isFullWidth={true} justifyContent='space-between'>
                        <Body color={'medium'}>{props.timeInStage || '0 minutes'}</Body>
                    </Stack>
                </Stack>
            )}
            <Stack spacing={4}>
                <Body size='small' color='dark' isBold={true} as='div'>
                    Goal
                </Body>
                {props.goals && props.goals.length > 0 ? (
                    props.goals.map((goal) => (
                        <Stack isHorizontal={true} spacing={4} alignItems='center' key={goal}>
                            <StageGoalIcon size={12} wrapWithDiv={false} />
                            <Body>{goal}</Body>
                        </Stack>
                    ))
                ) : (
                    <Body color='placeholder'>A goal has not been set for this stage</Body>
                )}
            </Stack>
            <Stack spacing={4}>
                <Body size='small' color='dark' isBold={true} as='div'>
                    Guidance
                </Body>
                <Body color={props.guidance ? 'medium' : 'placeholder'}>
                    {renderGuidanceContent()}
                </Body>
            </Stack>
        </div>
    );
}
